import Coordinate from "./Coordinate";
import ImageHorizontalBorder from "./ImageHorizontalBorder";
import ImageVerticalBorder from "./ImageVerticalBorder";

export default class ImageCoordinate extends Coordinate {
    /**
     * @type {ImageHorizontalBorder}
     */
    horizontal;

    /**
     * @type {ImageVerticalBorder}
     */
    vertical;

    constructor(provider, absX, absY, parent) {
        super(provider, absX, absY);
        this.parent = parent;
    }

    setRelations(horizontal, vertical) {
        this.horizontal = horizontal;
        this.vertical = vertical;
    }

    move() {
        this.horizontal.updatePositions();
        this.vertical.updatePositions();

        this.parent.updateCorners();
    }

    mouseOver(viewX, viewY) {
        if (!this.hovered(viewX, viewY)) {
            return false;
        }

        this.setCursor();
        return true;
    }

    setCursor() {
        return (this.absX >= 0
            && this.absY >= 0)
            || (this.absX <= 0
                && this.absY <= 0)
            ? this.cursor.resizeNWSE(this.parent.rotation)
            : this.cursor.resizeNESW(this.parent.rotation);
    }
}
